import React from 'react'
import { makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles(() => ({
	root: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& .MuiTextField-root': {
			width: '60%',
			'& .MuiFormLabel-root': {
				transform: 'translate(1.8rem, 1.8rem) scale(1)'
			},
			'& .MuiInputLabel-shrink': {
				transform: 'translate(1.8rem, 0.5rem) scale(.75)'
			},
			'& .MuiOutlinedInput-multiline': {
				'& .MuiOutlinedInput-inputMultiline': {
					padding: '1.8rem 1rem'
				},
				'& .MuiOutlinedInput-notchedOutline > legend': {
					display: 'none'
				}
			}
		}
	}
}))

const MultilineTextField = (props) => {
	const classes = useStyles()
	return (
		<div className={classes.root}>
			<TextField multiline {...props} />
		</div>
	)
}

export default MultilineTextField
